import { Theme, makeStyles } from '@material-ui/core';
import { GridLoaderProps } from '.';

export const useGridLoaderStyles = makeStyles<Theme, GridLoaderProps>(
  ({ spacing, palette }) => ({
    grayBorder: {
      border: `1px solid ${palette.divider}`,
      borderRadius: ({ newDesign }) => (newDesign ? 16 : spacing(2)),
      width: ({ itemWidth }) => itemWidth,
      background: ({ newDesign }) => (newDesign ? '#fff' : 'transparent'),
      padding: ({ newDesign }) => (newDesign ? 12 : 0)
    },
    categoryLoaderMargin: {
      marginTop: spacing(2)
    },
    container: {
      height: '100%',
      marginTop: ({ gap }) => gap || 0
    },
    wrapper: {
      display: 'flex',
      gap: ({ gap }) => gap,
      flexWrap: 'wrap'
    },
    title: {
      margin: spacing(1, 0)
    },
    imageSkeleton: {
      height: 180,
      borderRadius: ({ newDesign }) => (newDesign ? 12 : spacing(2))
    },
    resource: {
      display: 'flex',
      alignItems: 'center',
      gap: spacing(1)
    }
  })
);
